export const renderName = (user: any | null | undefined = null): string => {
  if (!user) return "-";

  const firstName = user.firstName?.trim();
  const lastInitial = user.lastName?.trim().charAt(0);

  if (!firstName && !lastInitial) return "-";
  if (!lastInitial) return firstName;

  return `${lastInitial}.${firstName ?? "-"}`;
};
